import { render, staticRenderFns } from "./SetFloatingData.vue?vue&type=template&id=5836a944&"
import script from "./SetFloatingData.vue?vue&type=script&lang=js&"
export * from "./SetFloatingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports